/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.IQ11TokenizeResponse,
  iQ11Tokenize: (params: vp.IQ11TokenizeRequest) => void,
  iQ11TokenizeAsync: (params: vp.IQ11TokenizeRequest) => Promise<vp.IQ11TokenizeResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostIQ11Tokenize: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldInteracMoneyRequest, setShouldInteracMoneyRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.IQ11TokenizeRequest>({
    PortalUser: '',
    AccountHolderName: '',
    ClientControlled: false,
    ClientAccountID: '',
  });
  const [response, setResponse] = useState<vp.IQ11TokenizeResponse>({
    Success: false,
    ErrorMessage: '',
    Token: '',
  });

  useEffect(() => {
    if (!shouldInteracMoneyRequest) return () => {};

    const PostInteracMoneyRequest = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postIQ11Tokenize(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldInteracMoneyRequest) void PostInteracMoneyRequest();
    setShouldInteracMoneyRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldInteracMoneyRequest]);

  return [
    response,
    (_params: vp.IQ11TokenizeRequest) => {
      setParams(_params);
      setShouldInteracMoneyRequest(true);
    },
    async (_params: vp.IQ11TokenizeRequest) => api.postIQ11Tokenize(_params, source),
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Token: '',
      });
      setShouldInteracMoneyRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostIQ11Tokenize);
